<template lang="pug">
v-card(width="900" flat)
    v-card-title.ai-generate-title.justify-center.text-center.pt-8.pb-0
        | {{$t('DOCUMENT_AGENT.AI_GENERATE_TITLE')}}

    v-card-text.pt-5.pb-5
        v-alert.mb-4(
            v-if="errorType"
            type="error"
            dense
            outlined
        )
            | {{ errorMessage }}

        v-textarea.ai-generate-textarea(
            v-model="prompt"
            :placeholder="$t('DOCUMENT_AGENT.AI_GENERATE_PLACEHOLDER')"
            outlined
            no-resize
            hide-details
            rows="8"
            maxlength="2000"
            :disabled="loading"
        )
        .ai-generate-char-count.text-right.mt-1
            span.caption.grey--text {{ prompt.length }} / 2000

    v-card-actions.ai-generate-actions.py-0
        v-spacer
        v-btn.ai-generate-btn.ai-generate-btn--secondary(
            :ripple="false"
            width="100"
            height="36"
            depressed
            outlined
            :disabled="loading"
            @click="onDirectCreate"
        )
            span {{$t('DOCUMENT_AGENT.DIRECT_CREATE_BTN')}}

        v-btn.ml-4.ai-generate-btn.ai-generate-btn--primary(
            :ripple="false"
            width="100"
            height="36"
            depressed
            :disabled="prompt.trim() === '' || loading"
            @click="onAiGenerate"
        )
            v-progress-circular(
                v-if="loading"
                indeterminate
                size="18"
                width="2"
                color="white"
            )
            span(v-else) {{generateBtnLabel}}
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        errorType: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            prompt: '',
            isRetryMode: false,
        };
    },
    computed: {
        errorMessage() {
            if (!this.errorType) return '';
            const keyMap = {
                timeout: 'DOCUMENT_AGENT.AI_GENERATE_ERROR_TIMEOUT',
                service_error: 'DOCUMENT_AGENT.AI_GENERATE_ERROR_SERVICE',
                invalid_format: 'DOCUMENT_AGENT.AI_GENERATE_ERROR_FORMAT',
                create_failed: 'DOCUMENT_AGENT.AI_GENERATE_ERROR_CREATE',
            };
            return this.$t(keyMap[this.errorType] || '');
        },
        generateBtnLabel() {
            return this.isRetryMode ? this.$t('DOCUMENT_AGENT.RETRY_BTN') : this.$t('DOCUMENT_AGENT.AI_GENERATE_BTN');
        },
    },
    watch: {
        errorType(val) {
            if (val) this.isRetryMode = true;
        },
        loading(val) {
            if (val) this.isRetryMode = false;
        },
    },
    methods: {
        onAiGenerate() {
            this.$emit('emitAiGenerate', this.prompt);
        },
        onDirectCreate() {
            this.$emit('emitDirectCreate');
        },
    },
};
</script>

<style scoped>
.ai-generate-title {
    color: #04608b !important;
    font-size: 28px !important;
    font-weight: 700 !important;
}

.ai-generate-actions {
    height: 60px;
    padding-right: 28px !important;
    background-color: #f4f4f4;
}

.ai-generate-btn {
    height: 36px !important;
    border-radius: 4px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
}

.ai-generate-btn--secondary {
    background-color: #ffffff !important;
    border: 1px solid #666 !important;
    color: #666666 !important;
}

.ai-generate-btn--primary {
    background-color: #14c6de !important;
    color: #ffffff !important;
}

.ai-generate-btn--primary .v-btn__content,
.ai-generate-btn--primary.v-btn--disabled .v-btn__content {
    color: #ffffff !important;
}

.ai-generate-btn--primary.v-btn--disabled {
    background-color: #d0d0d0 !important;
    color: #ffffff !important;
    opacity: 1 !important;
}

.ai-generate-textarea {
    width: 640px !important;
    margin: 0 auto !important;
    border-radius: 12px !important;
}

.ai-generate-textarea ::v-deep .v-input__slot {
    padding: 12px !important;
    border-radius: 12px !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
    box-shadow: none !important;
    transition: box-shadow 0.2s ease, transform 0.2s ease !important;
    margin-right: 0 !important;
}

.ai-generate-textarea:hover ::v-deep .v-input__slot {
    box-shadow: 0 0 18px 0 rgba(153, 153, 153, 0.50) !important;
}

.ai-generate-textarea ::v-deep fieldset {
    border: 6px solid #f4f4f4 !important;
}

.ai-generate-textarea ::v-deep textarea::placeholder {
    font-size: 16px !important;
    color: #999 !important;
}

.ai-generate-textarea ::v-deep textarea {
    padding: 0px 12px 12px 12px !important;
    margin: 0 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    box-sizing: border-box !important;
}

.ai-generate-char-count {
    width: 640px;
    margin: 0 auto;
}
</style>
